import gql from 'graphql-tag';

export const BRAND = gql`
	query brand($id: ID!){
		brand(id:$id){
			seoTitle
			seoDescription
			id
			name
			createdAt
      tnc
			url
			images{
				url(size: "1920x350")
        alt
        mobileUrl(size: "768x730")
			}
			categories(first: 99, level:2){
				totalCount
				edges {
					node {
            parent {
              name
              id
						}
            products(brand: $id){
              totalCount
            }
						level
						id
						name
						slug
            url
					}
				}
			}
		}
	}
`;